import React from 'react';
import cx from 'classnames';

import classes from './TextBlock.module.scss';

interface IProps {
  title?: string;
  children: React.ReactNode;
  variant?: 'BLUE' | 'GREEN' | 'ORANGE' | 'RED' | 'SIMPLE';
  className?: string;
}

const TextBlock: React.FC<IProps> = ({ title, children, variant, className }) => (
  <div className={cx(classes.wrapper, className, variant && classes[`wrapper--${variant}`])}>
    {!!title && (
      <div className={classes.title}>{title}</div>
    )}
    {!!children && (
      <div className={classes.description}>{children}</div>
    )}
  </div>
);

export default TextBlock;